/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable no-nested-ternary */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import * as AppPropTypes from '../../lib/PropTypes';

import { useLocales } from '../../contexts/SiteContext';
import { useThemeClassName } from '../../contexts/ThemeContext';
import StyledButton from '../buttons/StyledButton';

import styles from '../../../styles/partials/other-locales.module.scss';

const propTypes = {
    withFullLabel: PropTypes.bool,
    withButton: PropTypes.bool,
    linkClassName: PropTypes.string,
    pageUrls: AppPropTypes.pageUrls,
    className: PropTypes.string,
};

const defaultProps = {
    withFullLabel: false,
    withButton: false,
    linkClassName: null,
    pageUrls: null,
    className: null,
};

function OtherLocales({ withFullLabel, withButton, linkClassName, pageUrls, className }) {
    const locales = useLocales();
    const { locale } = useIntl();
    const themeClassName = useThemeClassName(styles);

    const otherLocales = useMemo(
        () => locales.filter((value) => value !== locale),
        [locales, locale],
    );

    const Tag = withButton ? StyledButton : 'a';

    return (
        <div
            className={classNames([
                styles.container,
                { [themeClassName]: themeClassName !== null, [className]: className !== null },
            ])}
        >
            {otherLocales.map((otherLocale) => (
                <Tag
                    key={`locale-${otherLocale}`}
                    className={classNames([
                        styles.link,
                        { [styles.button]: withButton, [linkClassName]: linkClassName !== null },
                    ])}
                    href={(pageUrls || {})[otherLocale] || ''}
                    target="_self"
                    {...(withButton ? { external: true } : null)}
                >
                    {withFullLabel ? (
                        otherLocale === 'en' ? (
                            <FormattedMessage defaultMessage="English" description="Locale" />
                        ) : (
                            <FormattedMessage defaultMessage="Français" description="Locale" />
                        )
                    ) : (
                        otherLocale
                    )}
                </Tag>
            ))}
        </div>
    );
}

OtherLocales.propTypes = propTypes;
OtherLocales.defaultProps = defaultProps;

export default OtherLocales;
